module.exports = __webpack_public_path__ + "static/11-611a3a4883e1b8c1854689f0c7ad571d.jpg";